<template>
	<el-container id="ordenesproductos">
		<el-dialog
			:visible.sync="dialogVisible"
			:title="productoSelected.nombre"
			:modal="true"
			:center="true"
			:show-close="false"
			width="30%"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
		>
			<el-alert v-if="cargado" title="Atención" type="warning" :closable="false"
				>El producto ya se encuentra cargado en el carrito pude agregar mas unidades del mismo.Si desea cambiarle el precio elimine el
				producto del carrito y vuelvalo a cargar</el-alert
			>
			<span style="text-align: center;">
				<p>
					Última compra : {{ productoSelected.ultprec_cantidad_conformato }} a {{ productoSelected.ultprecio_importe_conformato }} el
					{{ productoSelected.ultprec_fecha | dateFormat }}
				</p>
				<div>
					<el-input-number v-model="numero" :min="1"></el-input-number>
					<el-input
						v-if="!cargado"
						style="padding-top: 10px; margin-left: 5px; width: 150px;"
						inputmode="decimal"
						@input="inputValidator(precio)"
						@keydown.native="pressKey($event)"
						v-model="precio"
						:placeholder="productoSelected.ultprecio_importe_conformato"
					></el-input>
					<p v-if="!cargado">
						<b
							>Subtotal: <currency v-if="!isNaN(subtotal)" :value="subtotal" signo="$"></currency>
							<p v-else>--</p>
							<p></p
						></b>
					</p>
				</div>
			</span>
			<span slot="footer">
				<el-button @click="cancel">Cancelar</el-button>
				<el-button :disabled="isNaN(subtotal)" type="primary" @click="confirm">Aceptar</el-button>
			</span>
		</el-dialog>
		<el-row type="flex" justify="center">
			<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18">
				<filtros modulo="ocompra" v-if="!responsive.isMobile" />
				<el-button-group v-if="!$route.path.slice(13) && !responsive.isMobile">
					<el-button type="text" style="padding-right: 10px;" size="mini" @click="visibleTable = true"
						><i class="el-icon-linear-menu2">66888</i></el-button
					>
					<el-button type="text" size="mini" @click="visibleTable = false"><i class="el-icon-linear-icons2">7777</i></el-button>
				</el-button-group>
				<el-col
					:span="!responsive.isMobile ? 20 : 24"
					:class="{ productos: true, grid: !visibleTable, row: visibleTable }"
					v-loading="loadingproducto"
					element-loading-text="Cargando..."
				>
					<div style="text-align: right;">
						<el-button
							style="margin-right: 20px; margin-top: 5px;"
							icon="el-icon-refresh"
							circle
							@click="refreshAllProducts()"
						></el-button>
					</div>
					<el-alert
						v-if="!loadingproducto && productos.length === 0"
						title="No se encontraron productos"
						description="Pruebe otros criterios de búsqueda"
						type="warning"
						center
						:closable="false"
						show-icon
					>
					</el-alert>
					<!-- @click.native="redirect(producto.id, producto)" -->

					<el-card
						v-else
						v-for="producto in productos"
						:key="producto.id"
						class="producto"
						shadow="hover"
						@click.native="responsive.isMobile ? load(producto.id, producto) : false"
					>
						<el-row :gutter="20" v-if="!responsive.isMobile">
							<el-col :span="2">
								<el-image
									class="pic"
									:src="'./api/public/proxy/files?&cooperativa=' + cooperativa + '&type=pedidos&archivo=' + producto.url[0]"
									fit="contain"
								>
									<div slot="placeholder" class="pic slot">
										Cargando...
									</div>
									<div slot="error" class="pic slot">SIN FOTO</div>
								</el-image>
							</el-col>
							<el-col :span="responsive.isMobile ? 18 : 18">
								<div :class="responsive.isMobile ? 'contentMobile' : 'content'" style="width: 100%;">
									<div>
										<b>{{ producto.nombre }}</b>
									</div>
									<div style="margin-left: 10px;">
										{{ 'Código: ' + producto.codigo_alfanumerico }}
									</div>
									<div style="margin-left: 10px;" v-if="producto.factor_venta !== '1.000000'">
										{{ 'Stock actual: ' + producto.cantidad_envase_con_formato + ' ' + producto.unidad_medida_completa }}
									</div>
								</div>
								<div :class="responsive.isMobile ? 'contentMobile' : 'content'">
									<p>
										Última compra : {{ producto.ultprec_cantidad_conformato }} a {{ producto.ultprecio_importe_conformato }} el
										{{ producto.ultprec_fecha | dateFormat }}
									</p>
								</div>
								<div :class="responsive.isMobile ? 'contentMobile' : 'content'">
									<p>Stock actual: {{ producto.stock_cantidad_conformato }}</p>
								</div>
							</el-col>
							<el-col :span="responsive.isMobile ? 2 : 4"
								><div><el-button type="primary" @click="load(producto.id, producto)">Cargar</el-button></div></el-col
							>
						</el-row>
						<el-row :gutter="20" v-if="responsive.isMobile">
							<el-col :span="6">
								<!--	:src="'./api/public/proxy/files?&cooperativa=' + cooperativa + '&type=pedidos&archivo=' + producto.url[0]"-->

								<el-image
									class="pic"
									:src="'./api/public/proxy/files?&cooperativa=' + cooperativa + '&type=pedidos&archivo=' + producto.url[0]"
								>
									<div slot="placeholder" class="pic slot">
										Cargando...
									</div>
									<div slot="error" class="pic slot">SIN FOTO</div>
								</el-image>
							</el-col>
							<el-col :span="17">
								<div class="contentMobile" style="width: 100%;">
									<div>
										<b>{{ producto.nombre }}</b>
									</div>
									<div>
										<p>{{ 'Código: ' + producto.codigo_alfanumerico }}</p>
									</div>
								</div>
								<div class="contentMobile">
									<p>
										Última compra : {{ producto.ultprec_cantidad_conformato }} a {{ producto.ultprecio_importe_conformato }} el
										{{ producto.ultprec_fecha | dateFormat }}
									</p>
								</div>
								<div class="contentMobile">
									<p>Stock actual: {{ producto.stock_cantidad_conformato }}</p>
								</div>
							</el-col>
							<!-- <el-col :span="2"
								><div><el-button @click="load(producto.id, producto)">Cargar</el-button></div></el-col
							> -->
						</el-row>
					</el-card>
				</el-col>
			</el-col>
		</el-row>
		<!-- v-if="!this.$route.path.slice(13)" -->
		<el-row class="el-row is-justify-center el-row--flex" v-if="true">
			<el-col :xs="21" :sm="21" :md="12" :lg="12" :xl="12">
				<el-pagination
					layout="prev, pager, next"
					hide-on-single-page
					:page-size="limit"
					:total="total"
					@current-change="changepage"
					style="margin-top: 10px;"
				/>
			</el-col>
		</el-row>
	</el-container>
</template>
<script>
import filtros from '@/components/Filtros.vue';
// import Producto from '@/models/Producto';
import Currency from '@/components/Currency.vue';
import ElAlert from '@/overrides/ElAlert.vue';
export default {
	name: 'productos',
	inject: ['responsive'],
	components: {
		filtros,
		Currency,
		ElAlert,
	},
	data() {
		return {
			dialogVisible: false,
			filter: {
				patron: '',
				familia_id: '',
				subfamilia_id: '',
				unidad: '',
				presentacion_id: '',
				rubro_id: '',
				subrubro_id: '',
				linea_id: '',
				marca_id: '',
				es_nuevo: false,
				es_promocion: false,
			},

			loadingSelect: false,
			precio: '',
			precio_final: 0,
			numero: 1,
			start: 0,
			limit: 12,
			page: 1,
			visibleTable: true,
			visibleCarrito: false,
			dashboard: true,
			productoSelected: {},
			historial: false,
			subtotal: 0,
			cargado: false,
		};
	},

	computed: {
		tituloResumen() {
			return this.$route.name;
		},
		productos() {
			return this.$store.state.ordenescompra.productos;
		},
		total() {
			return this.$store.state.ordenescompra.total;
		},
		unidades() {
			return this.$store.state.ordenescompra.unegocio;
		},
		familia() {
			return this.$store.state.ordenescompra.familia;
		},
		subfamilia() {
			return this.$store.state.ordenescompra.subfamilia;
		},
		presentacion() {
			return this.$store.state.ordenescompra.presentacion;
		},
		rubro() {
			return this.$store.state.ordenescompra.rubro;
		},
		subrubro() {
			return this.$store.state.ordenescompra.subrubro;
		},
		linea() {
			return this.$store.state.ordenescompra.linea;
		},
		marca() {
			return this.$store.state.ordenescompra.marca;
		},
		loadingproducto() {
			return this.$store.state.ordenescompra.loadingproducto;
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
		idcarrito() {
			return this.$store.state.ordenescompra.idcarrito;
		},
		carrito() {
			return this.$store.state.ordenescompra.carrito;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		singular: function (name) {
			return name;
			//return name.substring(name.length, name.length - 2) === 'es' ? name.substring(0, name.length - 2) : name.substring(0, name.length - 1);
		},
	},
	watch: {
		precio_final(val) {
			this.subtotal = val * this.numero;
		},
		numero(val) {
			console.log('precio final', this.precio_final);
			var input_val = val * this.precio_final;
			this.subtotal = parseFloat(input_val);
		},
	},
	methods: {
		onChangeSearch(value, select) {
			this.start = 0;
			this.limit = 12;
			this.page = 1;
			this.$parent.$parent.armoLLamada(this.filter, this.start, this.limit, this.page);
		},
		cancel() {
			this.precio = '';
			this.precio_final = 0;
			this.numero = 1;
			this.subtotal = 0;
			this.cargado = false;
			this.dialogVisible = false;
		},
		reset() {
			//this.$refs['filter'].resetFields();
			//TODO: ver pq no puedo hacer andar la función
			this.filter.familia_id = '';
			this.filter.subfamilia_id = '';
			this.filter.negocio_id = '';
			this.filter.presentacion_id = '';
			this.filter.rubro_id = '';
			this.filter.subrubro_id = '';
			this.filter.linea_id = '';
			this.filter.marca_id = '';
			this.filter.es_nuevo = false;
			this.filter.es_promocion = false;
			this.callProductos();
		},
		getEmpty() {},
		load(id, producto) {
			this.findInCarrito(id);
			this.precio = producto.ultprecio_importe_conformato;
			this.precio_final = producto.ultprecio_importe;
			this.productoSelected = producto;
			this.dialogVisible = !this.dialogVisible;
		},
		setDashboard(value) {
			this.dashboard = value;
		},
		goBack() {
			commit('setTotalComprados', response.data.total);
		},
		changepage(ps) {
			this.start = ps * this.limit - this.limit;
			this.page = ps;
			this.$parent.$parent.$parent.$parent.armoLLamada(this.filter, this.start, this.limit, this.page);
			//this.callProductos();
		},
		callProductos() {
			let filtros = this.filter,
				start = this.start,
				limit = this.limit,
				page = this.page;
			this.$store.dispatch('loadProductosOrdenes', { params: { filtros, start, limit, page } });
			//console.log('esta es parente', this.$parent);
			//this.$parent.$parent.armoLLamada(this.filter, this.start, this.limit, this.page);
		},
		loadSelect(event, method) {
			this.loadingSelect = true;
			if (event) this.$store.dispatch(method, this.filter).then(asd => (this.loadingSelect = false));
		},
		inputValidator(value) {
			const input = document.querySelector(`#currency`);
			function formatNumber(n) {
				return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			}
			var input_val = value;
			if (!input_val || input_val === '') return;
			if (input_val.indexOf(',') >= 0) {
				var decimal_pos = input_val.indexOf(',');
				// split number by decimal point
				var left_side = input_val.substring(0, decimal_pos);
				var right_side = input_val.substring(decimal_pos);
				// add commas to left side of number
				left_side = formatNumber(left_side);
				// validate right side
				right_side = formatNumber(right_side);
				// Limit decimal to only 2 digits
				right_side = right_side.substring(0, 2);
				// join number by .
				input_val = '$' + left_side + ',' + right_side;
			} else {
				input_val = formatNumber(input_val);
				input_val = '$' + input_val;
			}
			this.precio = input_val;
			function revertirTransformacion(val) {
				val = val.replace('$', '').replace(/\./g, '').replace(/,/g, '.');
				return parseFloat(val);
			}
			this.precio_final = revertirTransformacion(input_val);
		},
		pressKey(event) {
			let key = event.key;
			if (key === 'Unidentified' || key === '.') {
				key = ',';
				this.precio += key;
			}
		},
		confirm() {
			const producto = this.productoSelected;
			let value = this.precio.replace('$', '').replace(/\./g, '').replace(/,/g, '.');
			producto['pedido_cantidad'] = this.numero;
			producto['pedido_id'] = this.idcarrito;
			producto.precio_final = value;
			this.$store.dispatch('addProductoOrden', producto);
			this.cancel();
		},
		formatNumber(n) {
			return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		},
		refreshAllProducts() {
			this.$store.dispatch('loadEntitityDataOcompra').then(() => {
				this.callProductos();
			});
		},
		findInCarrito(id) {
			//this.cargado = this.carrito.find(pro => pro.producto_id === id);
		},
	},
	mounted() {
		this.$store.dispatch('loadEntitityDataOcompra').then(() => {
			this.callProductos();
			this.$store.dispatch('loadCarritoOrdenes');
		});
	},
};
</script>
<style lang="scss">
#ordenesproductos {
	.productos {
		display: grid;
		grid-gap: 10px;
		.producto {
			cursor: pointer;
		}
		&.grid {
			grid-template-columns: 1fr 1fr 1fr;
			.pic {
				width: 100%;
				height: 125px;
			}
			.content {
				margin-top: 10px;
			}
			.contentMobile {
				margin-top: 5px;
			}
		}
		&.row {
			.pic {
				min-width: 60px;
				width: 100px;
				height: 90px;
				vertical-align: top;
			}
			.content {
				display: inline-flex;
				margin-left: 20px;
				font-size: 16px;
				line-height: 25px;
				//max-width: 250px;
			}
			.contentMobile {
				display: inline-block;
				margin-left: 30px;
				font-size: 14px;
				line-height: 16px;
				//max-width: 160px;
			}
		}
		.content b {
			font-size: 20px;
		}
		.contentMobile b {
			font-size: 20px;
		}
		.contentMobile p {
			margin: 7px !important;
		}
		.pic.slot {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #efefef;
			font-size: 12px;
		}
		.badge {
			margin-left: 5px;
		}
	}

	.header {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		margin-bottom: 20px;
		padding-bottom: 20px;
		h6 {
			font-size: 18px;
		}
		.entidad {
			font-family: 'Open Sans', sans-serif;
			font-size: 23px;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.25px;
			font-stretch: normal;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}

		.el-tabs {
			position: relative;
			top: 1px;
			.el-tabs__header {
				margin: 0;
				.el-tabs__nav {
					border: 0;
				}
			}
			.el-tabs__item {
				background-color: var(--main-color);
				color: #fff;
				&.is-active {
					background-color: #fff;
					color: var(--main-color);
				}
			}
		}
	}
}
</style>
